import { Component, h } from 'preact';
import Contest from '../componentsV2/Contest';

import { RESULTS_URL } from '../endpoints';

class EmbedApp extends Component {
  constructor() {
    super();

    this.state = { contests: [] };

    this.child = new pym.Child({ polling: 2500 });

    this.fetchData = this.fetchData.bind(this);
  }

  fetchData() {
    const selectedContests = this.props.selectedContests;

    fetch(RESULTS_URL)
      .then(res => res.json())
      .then(contests => {
        const activeContests = contests.filter(contest => {
          const slug = `${contest.office_slug}${
            contest.division_type === 'statewide' ? '' : `-${contest.district}`
          }-${contest.party.slice(0, 3)}`;

          return selectedContests.indexOf(slug) >= 0;
        });

        this.setState({ contests: activeContests }, this.startTimer);
      });
  }

  startTimer() {
    this.timer = setTimeout(this.fetchData, 1000 * 30);
  }

  clearTimer() {
    clearTimeout(this.timer);
  }

  componentDidMount() {
    this.fetchData();
    this.child.sendHeight();
  }

  componentDidUnmount() {
    this.clearTimer();
  }

  componentDidUpdate() {
    this.child.sendHeight();
  }

  render({}, { contests }) {
    return (
      <div class="embed">
        {contests.map(contest => (
          <Contest
            key={contest.id}
            includeContestCaptionDetail
            contest={contest}
          />
        ))}
      </div>
    );
  }
}

export default EmbedApp;



// WEBPACK FOOTER //
// ./components/EmbedApp.js